import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { BottomNav } from '../obros/BottomNav';
import { useAuthStore } from '../../stores/authStore';

// Raíces de las 4 tabs de app/obros/lib/screens/main_screen.dart (IndexedStack). Todo lo demás
// (detalle de job/propuesta, chat, wizards) se navega apilado arriba y oculta el tab bar.
const tabRoutes = ['/', '/workers', '/my-jobs', '/profile'];

export const MainLayout: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  const noSidebarRoutes = ['/', '/jobs', '/worker/jobs', '/workers', '/login', '/register'];
  const showSidebar = isAuthenticated && !noSidebarRoutes.includes(location.pathname);
  const showBottomNav = isAuthenticated && tabRoutes.includes(location.pathname);

  return (
    // Shell de altura fija (como el ObrosPhone del diseño): Navbar y BottomNav quedan
    // pinneados, y solo <main> scrollea — así una pantalla corta (ej. Home con poco
    // contenido) entra completa sin dejar scroll de página de más.
    <div className="h-screen flex flex-col overflow-hidden bg-secondary-50">
      <Navbar />
      <div className="flex-1 flex overflow-hidden">
        {showSidebar && <Sidebar />}
        {/* min-w-0: un hijo flex con contenido de scroll horizontal (chips) no tiene límite de
            ancho por defecto y termina empujando todo de costado si no se lo frena acá. */}
        <main className={`flex-1 min-w-0 overflow-y-auto ${showBottomNav ? 'pb-16 lg:pb-0' : ''}`}>
          <Outlet />
        </main>
      </div>
      {showBottomNav && <BottomNav />}
    </div>
  );
};
